<template>
  <div id="view">
    <div class="image-section" id="img-1">
      <imageContainer class="image"
                      :imageName="'SZY_9803'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <h1 class="title">A Csapat</h1>
      <div @click="scrollToSection('#team')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="team">
      <div class="decoration"></div>
      <div class="content" v-if="people">
          <h2>2020-as Szervezők</h2>
          <div class="people">
            <div v-for="person in team2020" class="person">
              <div class="img-wrapper">
                <img :src="personImg(person.image)"/>
              </div>
              <div class="text">
                <h3>{{person.name}}</h3>
                <p v-if="person.description">{{person.description}}</p>
              </div>
            </div>
            <h3>Önkéntesek</h3>
            <p v-html="volunteers20.text"></p>
          </div>
          <h2>2019-es Szervezők</h2>
          <div class="people">
            <div v-for="person in team2019" class="person">
              <div class="img-wrapper">
                <img :src="personImg(person.image)"/>
              </div>
              <div class="text">
                <h3>{{person.name}}</h3>
                <p v-if="person.description">{{person.description}}</p>
              </div>
            </div>
            </div><h3>Önkéntesek</h3>
            <p v-html="volunteers19.text"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import imageContainer from './../components/imageContainer.vue'
  import arrowSvg from './../components/arrow.vue'

  export default {
    name: 'teamPage',
    components: {
      imageContainer,
      arrowSvg
    },
    computed: {
      people () {
        return this.$store.state.about.people
      },
      volunteers19 () {
        return this.$store.state.about.people.volunteers19[0]
      },
      volunteers20 () {
        return this.$store.state.about.people.volunteers20[0]
      },
      personImg () {
        return (imgPath) => {
          return `${this.$store.state.config.baseURL}${imgPath}`
        }
      },
      team2019 () {
        return this.$store.state.about.people.team.filter(p => {
          return !p.name.toLowerCase().includes('samu') &&
          !p.name.toLowerCase().includes('mercédesz') &&
          !p.name.toLowerCase().includes('laura')
        });
      },
      team2020 () {
        const p1 = this.$store.state.about.people.team.find(p => p.name.toLowerCase().includes('samu'))
        const p2 = this.$store.state.about.people.team.find(p => p.name.toLowerCase().includes('laura')) || {}
        const p3 = this.$store.state.about.people.team.find(p => p.name.toLowerCase().includes('mercédesz'))

        return [p1, p2, p3]
      }
    },
    mounted () {
      this.$store.dispatch('about/getTeam')
      this.$store.dispatch('theme/getTheme', '2020');
    }
  }
</script>

<style scoped>
  #view {
    position: relative;
  }

  .image-section {
    position: relative;
    width: 100%;
    font-size: 0;
  }

  .image {
    opacity: 0.8;
  }

  .title {
    position: absolute;
    left: 50%;
    top: 20vh;
    margin: 0 0 10px;
    font-size: 120px;
    color: var(--colorA);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
    transform: translateX(-50%);
  }

  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorA);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorA);
    box-sizing: border-box;
  }

  #team {
    position: relative;
    min-height: 100vh;
    padding: 60px 40px;
    border: 10px solid var(--colorA);
    box-sizing: border-box;
  }

  #team h2 {
    top: 0;
    left: 0;
    margin-top: 0;
    margin-bottom: 30px;
    color: var(--colorB);
    align-items: center;
    text-transform: uppercase;
  }

  .content {
    width: 66%;
    max-width: 960px;
    text-align: left;
  }

  .decoration {
    position: absolute;
    width: calc(100vw / 7);
    height: 70vh;
    top: 30vh;
    right: 0;
    background-color: var(--colorA);
    opacity: 0.76;
    z-index: -1;
  }

  .people:first-of-type {
    margin-bottom: 60px;
  }

  .person {
    display: flex;
    margin-bottom: 40px;
  }

  .person:last-of-type {
    margin-bottom: 60px;
  }

  .person .img-wrapper {
    flex: 1 0 auto;
    width: 250px;
    height: 250px;
    margin-right: 40px;
  }

  .person img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .person h3 {
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 20px;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 15vh;
    }

    .content {
      width: 80%;
    }

    .person .img-wrapper {
      width: 200px;
      height: 200px;
    }

    .peron p {
      font-size: 16px;
    }
  }

  @media (max-width: 600px) {
    .title {
      top: 45vh;
      font-size: 9vh;
    }

    #team {
      padding: 60px 20px;
      height: auto;
    }

    #team h2 {
      padding-bottom: 10px;
      font-size: 21px;
    }

    .content {
      width: 100%;
      padding-top: 20px;
    }

    .person {
      flex-direction: column;
      align-items: center;
    }

    .person .img-wrapper {
      width: 100%;
      height: 100%;
      margin-right: 0;
      margin-bottom: 30px;
    }

    .decoration {
      display: none;
    }
  }

</style>
